import { render, staticRenderFns } from "./SubDevicesTable.vue?vue&type=template&id=a2d06d02&scoped=true"
import script from "./SubDevicesTable.vue?vue&type=script&lang=js"
export * from "./SubDevicesTable.vue?vue&type=script&lang=js"
import style0 from "./SubDevicesTable.vue?vue&type=style&index=0&id=a2d06d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d06d02",
  null
  
)

/* custom blocks */
import block0 from "./SubDevicesTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports